// utils.js
export const findAndReplace = (array, newObject) => {
  const index = array.findIndex((obj) => obj._id == newObject._id);
  if (index !== -1) {
    array[index] = newObject;
  }
  return array;
};
